export const MOBILE = '420 100 300 300';
export const TABLET = '280 100 600 300';
export const DESKTOP = '0 0 864 542';
